import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-hexagon-glow-svg',
  standalone: true,
  template: `
    <svg width="340" height="340" viewBox="0 0 340 340" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_f_hex_glow)">
        <circle cx="170" cy="170" r="50" [attr.fill]="color()"/>
      </g>
      <defs>
        <filter id="filter0_f_hex_glow" x="0" y="0" width="340" height="340" filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feGaussianBlur stdDeviation="60" result="effect1_foregroundBlur"/>
        </filter>
      </defs>
    </svg>
  `,
  styles: [`
    :host {
      display: block;
    }
    svg {
      display: block;
      width: 100%;
      height: 100%;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HexagonGlowSvgComponent {
  readonly color = input.required<string>();
}
